export default {
  title01: "Meteo attuale",
  title02: "24 ore",
  title03: "Visualizza previsioni meteo a 10 giorni",
  title04: "AQI",
  title05: "Visualizza tutte le informazioni",
  title06: "ALBA E TRAMONTO",
  title07: "FASE LUNARE",
  title08: "La prossima luna piena",
  title09: "La prossima luna nuova",
  title10: "GIORNO",
  title11: "NOTTE",
  title12: "Alba",
  title13: "Tramonto",
  title14: "Sorgere della luna",
  title15: "Tramonto della luna",
  title16: "Fonte",
  title17: "Inizio",
  title18: "Fine",
  title19: "Usa posizione attuale",
  title20: "Cerca la città",
  title21: "Sembra",
  title22: "Sembra ombra",
  title23: "Adesso",
  title24: "Oggi",
  title25: "DOM",
  title26: "LUN",
  title27: "MAR",
  title28: "MER",
  title29: "GIO",
  title30: "VEN",
  title31: "SAB",
  title32: "Caricamento...",
  title33: "Ora",
  title34: "Per Ora",
  title35: "Quotidiano",
  title36: "Sole e Luna",
  title37: "Qualità dell'aria",
  title38: "Contatto: xlf550402@gmail.com",
  title39: "Accordo sulla Privacy",
  title40: "Copyright © comfortweather.com 2020 - 2025. Tutti i diritti riservati.",
  title41: "Dati forniti da",
  title42: "Max",
  title43: "Min",
  title44: "Accetta",
  title45:
    "Grazie per aver utilizzato ComfortWeather! Per tutelare al meglio i vostri diritti e interessi legali, vi invitiamo a leggere attentamente la ",
  title46: "Politica sulla privacy",
  title47: " prima di utilizzarla.",
  title48: "",
  title49: "Contatto: xyjph123@gmail.com",
  title50: "Copyright © 24hweather.com 2020 - 2025. Tutti i diritti riservati.",
  title51:
    "Grazie per aver utilizzato 24hweather! Per tutelare al meglio i vostri diritti e interessi legali, vi invitiamo a leggere attentamente la ",
};
